import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserComponentsData {
  components: {
    label: string;
    value: string;
  }[];
}

export function useUserComponents() {
  const queryClient = useQueryClient();
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userComponents'],
    queryFn: async (): Promise<UserComponentsData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_user_components`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      // data.items is the array of components
      const components = data?.data?.items || [];

      console.dir(components);

      const uniqueComponents = components.filter(
        (
          component: { uuid: string },
          index: number,
          self: { uuid: string }[]
        ) => index === self.findIndex((t) => t.uuid === component.uuid)
      );

      console.dir(uniqueComponents);

      return {
        components: uniqueComponents,
      };
    },
  });
}
